'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = exports.load = exports.doLogin = exports.LOAD = exports.LOGOUT = exports.LOGIN = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.fetchLoginSaga = fetchLoginSaga;
exports.fetchLogoutSaga = fetchLogoutSaga;
exports.afterLogoutSaga = afterLogoutSaga;
exports.watchFecthLoginSaga = watchFecthLoginSaga;
exports.watchLogoutSaga = watchLogoutSaga;
exports.watchAfterLogoutSaga = watchAfterLogoutSaga;

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _reactRouterRedux = require('react-router-redux');

var _api = require('helpers/api');

var _api2 = _interopRequireDefault(_api);

var _createFetchTypes = require('../utils/createFetchTypes');

var _createFetchTypes2 = _interopRequireDefault(_createFetchTypes);

var _fetchEntitySaga = require('../utils/fetchEntitySaga');

var _fetchEntitySaga2 = _interopRequireDefault(_fetchEntitySaga);

var _notifications = require('./notifications');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(fetchLoginSaga),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(fetchLogoutSaga),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(afterLogoutSaga),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchFecthLoginSaga),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(watchLogoutSaga),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(watchAfterLogoutSaga);

var LOGIN = exports.LOGIN = (0, _createFetchTypes2.default)('tq-plus-admin/LOGIN');
var LOGOUT = exports.LOGOUT = (0, _createFetchTypes2.default)('tq-plus-admin/LOGOUT');
var LOAD = exports.LOAD = 'tq-plus-admin/LOAD';

var initialState = {
  isAuthenticated: false,
  token: null,
  codedToken: null,
  error: null
};

/* REDUCER
 * ---------------------------------------------------------------------------------------------- */
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'DELETE_TOKEN':
      {
        return {
          isAuthenticated: false,
          token: null,
          codedToken: null,
          error: null
        };
      }
    case LOGIN.REQUEST:
      return (0, _extends3.default)({}, state, { isAuthenticated: false, token: null, codedToken: null });
    case LOGIN.SUCCESS:
      return (0, _extends3.default)({}, state, {
        isAuthenticated: true,
        token: action.token,
        codedToken: action.codedToken
      });
    case LOGIN.FAILURE:
      return (0, _extends3.default)({}, state, {
        isAuthenticated: false,
        token: null,
        codedToken: null,
        error: action.error
      });

    case LOGOUT.REQUEST:
      return (0, _extends3.default)({}, state);
    case LOGOUT.SUCCESS:
      return (0, _extends3.default)({}, state, { isAuthenticated: false, token: null, codedToken: null });
    case LOGOUT.FAILURE:
      return (0, _extends3.default)({}, state, { error: action.error });

    case LOAD:
      {
        return (0, _extends3.default)({}, state, {
          token: action.token,
          codedToken: action.codedToken,
          isAuthenticated: true
        });
      }

    default:
      return state;
  }
}

/* ACTIONS
 * ---------------------------------------------------------------------------------------------- */
var doLogin = exports.doLogin = {
  base: function base(credentials) {
    return {
      type: LOGIN.BASE,
      url: '/auth-provider/do-login',
      data: { credentials: credentials },
      overwritePath: '/auth'
    };
  },
  request: function request() {
    return { type: LOGIN.REQUEST };
  },
  success: function success(result) {
    return {
      type: LOGIN.SUCCESS,
      token: result.token,
      codedToken: result.codedToken
    };
  },
  failure: function failure(error) {
    return { type: LOGIN.FAILURE, error: error };
  }
};

var load = exports.load = function load(token, codedToken) {
  return {
    type: LOAD,
    token: token,
    codedToken: codedToken
  };
};

var logout = exports.logout = {
  base: function base() {
    return {
      type: LOGOUT.BASE,
      url: '/auth-provider/logoff',
      overwritePath: '/auth/logout'
    };
  },
  request: function request() {
    return { type: LOGOUT.REQUEST };
  },
  success: function success() {
    return { type: LOGOUT.SUCCESS };
  },
  failure: function failure(error) {
    return { type: LOGOUT.FAILURE, error: error };
  }
};

function isLoaded(state) {
  return state.auth && state.auth.token && state.auth.isAuthenticated;
}

/* SAGAS
 * ---------------------------------------------------------------------------------------------- */
function fetchLoginSaga(_ref) {
  var url = _ref.url,
      data = _ref.data,
      overwritePath = _ref.overwritePath;
  var result;
  return _regenerator2.default.wrap(function fetchLoginSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySaga2.default)(doLogin, _api2.default.post, url, { data: data, overwritePath: overwritePath });
          });

        case 3:
          result = _context.sent;
          _context.next = 6;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/'));

        case 6:
          return _context.abrupt('return', result);

        case 9:
          _context.prev = 9;
          _context.t0 = _context['catch'](0);
          _context.next = 13;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error login in',
            message: _context.t0.message
          }));

        case 13:
          return _context.abrupt('return', _context.t0);

        case 14:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this, [[0, 9]]);
}

function fetchLogoutSaga(_ref2) {
  var url = _ref2.url,
      overwritePath = _ref2.overwritePath;
  var result;
  return _regenerator2.default.wrap(function fetchLogoutSaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0, _effects.call)(function () {
            return (0, _fetchEntitySaga2.default)(logout, _api2.default.get, url, { overwritePath: overwritePath });
          });

        case 3:
          result = _context2.sent;
          return _context2.abrupt('return', result);

        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2['catch'](0);
          _context2.next = 11;
          return (0, _effects.put)((0, _notifications.error)({
            title: 'Error login out',
            message: _context2.t0.message
          }));

        case 11:
          return _context2.abrupt('return', _context2.t0);

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[0, 7]]);
}

function afterLogoutSaga() {
  return _regenerator2.default.wrap(function afterLogoutSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.put)(window.location = process.env.LOGOUT_REDIRECT_URL);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

/* WATCHERS
 * ---------------------------------------------------------------------------------------------- */
function watchFecthLoginSaga() {
  return _regenerator2.default.wrap(function watchFecthLoginSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          return _context4.delegateYield((0, _reduxSaga.takeLatest)(LOGIN.BASE, fetchLoginSaga), 't0', 1);

        case 1:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function watchLogoutSaga() {
  return _regenerator2.default.wrap(function watchLogoutSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.delegateYield((0, _reduxSaga.takeLatest)(LOGOUT.BASE, fetchLogoutSaga), 't0', 1);

        case 1:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function watchAfterLogoutSaga() {
  return _regenerator2.default.wrap(function watchAfterLogoutSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          return _context6.delegateYield((0, _reduxSaga.takeLatest)(LOGOUT.SUCCESS, afterLogoutSaga), 't0', 1);

        case 1:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 128
// module chunks = 0